/* tslint:disable */
/* eslint-disable */
/**
 * Api Documentation
 * Api Documentation
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
import {
    JsonCompanyUserInfo,
    JsonCompanyUserInfoFromJSON,
    JsonCompanyUserInfoFromJSONTyped,
    JsonCompanyUserInfoToJSON,
} from './JsonCompanyUserInfo';

/**
 * 
 * @export
 * @interface ApiResultOfListOfJsonCompanyUserInfo
 */
export interface ApiResultOfListOfJsonCompanyUserInfo {
    /**
     * 
     * @type {Array<JsonCompanyUserInfo>}
     * @memberof ApiResultOfListOfJsonCompanyUserInfo
     */
    data?: Array<JsonCompanyUserInfo>;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyUserInfo
     */
    message?: string;
    /**
     * 
     * @type {object}
     * @memberof ApiResultOfListOfJsonCompanyUserInfo
     */
    messageValues?: object;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyUserInfo
     */
    requestId?: string;
    /**
     * 
     * @type {string}
     * @memberof ApiResultOfListOfJsonCompanyUserInfo
     */
    result?: ApiResultOfListOfJsonCompanyUserInfoResultEnum;
}

/**
* @export
* @enum {string}
*/
export enum ApiResultOfListOfJsonCompanyUserInfoResultEnum {
    Ok = 'OK',
    Error = 'ERROR'
}

export function ApiResultOfListOfJsonCompanyUserInfoFromJSON(json: any): ApiResultOfListOfJsonCompanyUserInfo {
    return ApiResultOfListOfJsonCompanyUserInfoFromJSONTyped(json, false);
}

export function ApiResultOfListOfJsonCompanyUserInfoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ApiResultOfListOfJsonCompanyUserInfo {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'data': !exists(json, 'data') ? undefined : ((json['data'] as Array<any>).map(JsonCompanyUserInfoFromJSON)),
        'message': !exists(json, 'message') ? undefined : json['message'],
        'messageValues': !exists(json, 'messageValues') ? undefined : json['messageValues'],
        'requestId': !exists(json, 'requestId') ? undefined : json['requestId'],
        'result': !exists(json, 'result') ? undefined : json['result'],
    };
}

export function ApiResultOfListOfJsonCompanyUserInfoToJSON(value?: ApiResultOfListOfJsonCompanyUserInfo | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'data': value.data === undefined ? undefined : ((value.data as Array<any>).map(JsonCompanyUserInfoToJSON)),
        'message': value.message,
        'messageValues': value.messageValues,
        'requestId': value.requestId,
        'result': value.result,
    };
}

